module.exports = __webpack_public_path__ + "static/media/padlock-dark.b03b281b.svg";